import $ from "jquery";

$(function initialize() {
  $(document).on('ready', function handleReady() {
    $('#composite_modifier_user_id_search').removeAttr('data-behavior-refresh-form');
  });
});
